import React, { Component } from 'react';
import { branch, renderComponent, compose, withHandlers } from 'recompose';
import { Redirect } from 'react-router-dom';
import { OrderLayout as Layout } from '../layout';
import Logo from '../../images/libudaLogo';
import OrderSuccess from './success';
import { FetchOrderStatusLoading } from '../../containers/status';

class Order extends Component {
  componentDidMount() {
    const { paymentMethod } = this.props;

    if (paymentMethod === 'giropay') {
      this.props.fetchOrderStatus();
    }
  }

  render() {
    const { invalidateOrder, payOrderStatus } = this.props;

    return (
      <Layout>
        <Layout.Header>
          <Logo width={100} />
        </Layout.Header>
        <Layout.Body>
          <FetchOrderStatusLoading />
          {payOrderStatus === 'success' && (
            <OrderSuccess invalidateOrder={invalidateOrder} />
          )}
        </Layout.Body>
      </Layout>
    );
  }
}

const redirectIfNoData = hasNoData =>
  branch(hasNoData, renderComponent(() => <Redirect to="/" />));

const redirectIfError = hasError =>
  branch(hasError, renderComponent(() => <Redirect to="/checkout/payorder" />));

const enchance = compose(
  redirectIfNoData(props => !props.activeOrder),
  redirectIfError(props => props.payOrderStatus === 'error'),
  withHandlers(initialProps => {
    const { activeOrder } = initialProps;

    return {
      fetchOrderStatus: props => () => {
        return props.fetchOrderStatus({ order_id: activeOrder.order_id });
      },
    };
  })
);

export default enchance(Order);



// WEBPACK FOOTER //
// ./src/components/order/index.js